import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { matchPath, useLocation } from 'react-router';

import { MODULE_ROUTES, type TModuleCode } from '@/shared/routes';
import { useAppSelector } from '@/store';

import { MODULE_ICONS, MODULE_TITLES } from '../constants';

export interface INavItem {
  code: TModuleCode;
  /** Название раздела. */
  label: string;
  route: string;
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
}

/**
 * Пункты основной навигации из разделов сессии и код активного раздела. Раздел
 * активен и на вложенных экранах (`/:lang/contracts/42` → «Контракты»).
 */
const useNavItems = (): { items: INavItem[]; activeCode?: TModuleCode } => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const modules = useAppSelector((state) => state.session.modules);

  const items = useMemo(
    () =>
      modules.map((code) => ({
        code,
        label: t(MODULE_TITLES[code]),
        route: MODULE_ROUTES[code],
        icon: MODULE_ICONS[code]
      })),
    [modules, t]
  );

  const activeCode = items.find((item) =>
    matchPath({ path: `/:lang/${item.route}`, end: false }, pathname)
  )?.code;

  return { items, activeCode };
};

export default useNavItems;
